import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "styles/scss/about.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import TopButton from "components/topbutton/TopButton";

function About() {

  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["2024 ~", "2023 ~ 2019", "2018 ~ 2014", "2013 ~ 2009", "2008 ~ 2003"];

  const [isLoaded, setIsLoaded] = useState(false);
  const swiperRef = useRef(null); 

  const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
  const [isVisionDropdownOpen, setIsVisionDropdownOpen] = useState(false);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.autoplay.start(); 
      setIsLoaded(true); 
    }
  }, []);

  return (
        <>
            <div>
                <TopButton />      
                <div className="infor-background">
                    <h1>회사 소개</h1>
                    <p>[ 비전 / 연혁 / 조직도 ]</p>
                    {/* 브레드크럼 */}
                    <div className="breadcrumb-box container">
                    <nav className="breadcrumb">
                        <ul>
                            <li className="home-icon">
                                <Link to="/">
                                    <span className="home"></span>
                                </Link>
                            </li>                  
                            <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                                회사소개
                                <span className="dropdown-icon">
                                    {isCompanyDropdownOpen ? "▲" : "▼"}
                                </span>
                                {isCompanyDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/about">회사소개</Link>
                                    </li>
                                    <li>
                                        <Link to="/business">비즈니스</Link>
                                    </li>
                                    <li>
                                        <Link to="/news">N소식</Link>
                                    </li>
                                    <li>
                                        <Link to="/recruitment">인재채용</Link>
                                    </li>
                                    </ul>
                                )}
                                </li>                  
                                <li className="dropdown" onClick={() => setIsVisionDropdownOpen(!isVisionDropdownOpen)}>
                                    비전,연혁
                                <span className="dropdown-icon">
                                    {isVisionDropdownOpen ? "▲" : "▼"}
                                </span>
                                {isVisionDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/about">비전,연혁</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/organization/:aboutId">조직도</Link>
                                    </li>
                                </ul>
                                )}
                            </li>
                        </ul>
                    </nav>
                    <div className="mobile">
                        <ul>
                            <li className="home-icon">
                            <Link to="/">
                                <span className="home"></span>
                            </Link>
                            </li>
                            <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                                회사소개
                                <span className="dropdown-icon">
                                    {isCompanyDropdownOpen ? "▲" : "▼"}
                                </span>
                                {isCompanyDropdownOpen && (
                                    <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/about">회사소개</Link>
                                    </li>
                                    <li>
                                        <Link to="/business">비즈니스</Link>
                                    </li>
                                    <li>
                                        <Link to="/news">N소식</Link>
                                    </li>
                                    <li>
                                        <Link to="/recruitment">인재채용</Link>
                                    </li>
                                    </ul>
                                )}
                            </li>
                            <li className="dropdown" onClick={() => setIsVisionDropdownOpen(!isVisionDropdownOpen)}>
                                비전,연혁
                                <span className="dropdown-icon">
                                    {isVisionDropdownOpen ? "▲" : "▼"}
                                </span>
                                {isVisionDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li>
                                        <Link to="/about">비전,연혁</Link>
                                    </li>
                                    <li>
                                        <Link to="/about/organization/:aboutId">조직도</Link>
                                    </li>
                                </ul>
                                )}
                            </li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div>
                    <ul className="titAndCeo">
                        {/* 대표인사 */}
                        <li className="ceo-infor">
                        <ul className="SeoYong-su-box">
                            <li className="ceo-txt">
                                <h3><span className="red">(주)엔정보기술은 언제나 고객만족을 최우선으로 생각합니다.</span></h3>
                                <p>
                                <br></br>
                                엔정보기술 홈페이지를 방문해 주셔서 감사합니다.
                                <br></br>
                                <br></br>
                                급변하는 IT 환경 속에서, 엔정보기술은 고객의 성공적인 비즈니스 혁신을 이끄는 신뢰 받는 파트너로 자리매김해 왔습니다. <br></br>
                                시스템과 네트워크는 물론, 클라우드와 AI 등 첨단 기술을 융합한 최적의 시스템 통합(SI) 솔루션을 제공하며, 고객 맞춤형 IT 환경을 구축하는 데 주력하고 있고,
                                축적된 경험과 기술력을 바탕으로 유연하고 확장 가능한 클라우드 인프라, AI 기반 지능형 서비스 등 디지털 전환을 위한 미래 지향적 시스템을 구현해 나가고 있습니다.
                                <br></br>
                                <br></br>
                                앞으로도 변화와 혁신을 두려워하지 않고, 고객과 함께 성장하며 새로운 가치를 창출하는 SI 전문 기업으로 나아가겠습니다.<br></br>
                                고객의 성공을 최우선으로 생각하며, 신뢰와 기술력을 바탕으로 최고의 동반자가 되겠습니다.<br></br>
                                많은 관심과 성원 부탁 드립니다.
                                </p>
                                <span className="ceo-sign">
                                    <span>(주)엔정보기술 대표이사 <span className="txtL">서용수 , 원종철</span></span>
                                </span>
                            </li>
                        </ul>
                    </li>
                    {/* 비전 */}
                    <li className="vision">
                        <div className="tit">
                            <h2>비전</h2>
                            <p>"엔정보기술은 개개인의 행복을 추구하는 <span className="red">인간중심의 기업</span>입니다."</p>
                        </div>
                        <div className="circle-box">
                            {/* 개인의행복 */}
                            <div className="circleAndP">
                                <div className="circle-flex">
                                    <span className="happy-icon"></span>
                                    <span className="circle-txt">개인의행복</span>
                                </div>
                                <p>보편적 가치인 개개인의 행복을 최우선 순위로 해가며 <br></br>서로를 존중하고 신뢰하는 인간중심의 회사를 추구합니다.</p>
                            </div>
                            {/* 가치창출 */}
                            <div className="circleAndP">
                                <div className="circle-flex circle-red">
                                    <span className="value-icon"></span>
                                    <span className="circle-txt">가치창출</span>
                                </div>
                                <p>기술 향상에 그치지 않고 수익을 창출하여 엔정보기술의 <br></br>밝은 미래를 열어갑니다.</p>
                            </div>
                            {/* 자기개발 */}
                            <div className="circleAndP">
                                <div className="circle-flex circle-red circle-black-mobile">
                                    <span className="self-icon"></span>
                                    <span className="circle-txt">자기개발</span>
                                </div>
                                <p>조직 내 구성원들이 최고의 경쟁력을 갖출 수 있도록 <br></br>역량 강화에 아낌없는 지원을 하겠습니다.</p>
                            </div>
                            {/* 신사업발굴 */}
                            <div className="circleAndP">
                                <div className="circle-flex circle-red-mobile">
                                    <span className="discovery-icon"></span>
                                    <span className="circle-txt">신사업발굴</span>
                                </div>
                                <p>빠르게 변화하는 환경에 민감하게 반응하고 고객의 요구에 <br></br>정확히 부합하는 솔루션을 구축해갑니다.</p>
                            </div>
                        </div>
                    </li>            
                    {/* 연혁 */}
                    <li className="history">
                        <h2>연혁</h2>
                        <p>" 미래를 향한 도전과 성과 "</p>
                        <div className="tabs-container">
                            <div className="tabs">
                                {tabs.map((tab, index) => (
                                <button
                                    key={index}
                                    className={activeTab === index ? "tab active" : "tab"}
                                    onClick={() => setActiveTab(index)}
                                >
                                    {tab}
                                </button>
                                ))}
                            </div>
                            <div className="tab-content">
                                {activeTab === 0 && <History2024 />}
                                {activeTab === 1 && <History2019 />}
                                {activeTab === 2 && <History2014 />}
                                {activeTab === 3 && <History2009 />}
                                {activeTab === 4 && <History2003 />}
                            </div>
                        </div>
                    </li>
                    {/* 협력사 로고 */}
                    <li className="partnerCompany">
                        <div className="tit">
                            <h2>협력사</h2>
                            <p>"함께 성장하는 최고의 파트너, 신뢰로 이어가는 미래"</p>
                        </div>
                        <div className="company-logo">
                            {/* Swiper 슬라이더 */}
                            <Swiper
                                ref={swiperRef} 
                                spaceBetween={5}
                                slidesPerView={5}
                                loop={true} 
                                autoplay={{
                                    delay: 3000, 
                                    disableOnInteraction: false,
                                }}
                                modules={[Pagination, Navigation, Autoplay]}
                                onSwiper={(swiper) => (swiperRef.current = swiper)}
                                breakpoints={{
                                    320: { slidesPerView: 1 },
                                    480: { slidesPerView: 1 },
                                    768: { slidesPerView: 2 },
                                    1024: { slidesPerView: 3 },
                                    1280: { slidesPerView: 5 },
                                }}
                            >
                                <SwiperSlide>
                                    <div className="img-box">
                                        <img src="/img/logo/lgCns.png"  alt="lgCns"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="img-box">
                                        <img src="/img/logo/mantechSolution.png"  alt="mantechSolution"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="img-box">
                                        <img src="img/logo/wins.png"  alt="wins"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="img-box">
                                        <img src="img/logo/JIRANSOFT.png"  alt="JIRANSOFT"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="img-box">
                                        <img src="img/logo/geomexsoft.svg"  alt="geomexsoft"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="img-box">
                                        <img src="img/logo/secuve.gif"  alt="secuve"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="img-box">
                                        <img src="img/logo/brainz.svg"  alt="brainz"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div>
                                        <img src="img/logo/inetbank.png"  alt="inetbank"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div>
                                        <img src="img/logo/cplatform.png"  alt="cplatform"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div>
                                        <img src="img/logo/piolink.png"  alt="piolink"></img>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div>
                                        <img src="img/logo/iwork.png"  alt="iwork"></img>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default About;

const History2024 = () => (
    <div>
        <p className="history-tit"> 2024년이후의 주요 연혁</p>
        <p className="history-p"> 오케스트로 Silver Partner </p>
        <p className="history-p"> 삼성SDS 클라우드(IaaS) 중개 제공자</p>
        <p className="history-p"> Dooray! 골드 파트너</p>
        <p className="history-p"> 삼성SDS 클라우드 서비스 파트너</p>
    </div>
);

const History2019 = () => (
    <div>
        <p className="history-tit">2023년 ~ 2019년 연혁</p>
        <p className="history-p"> 신시웨이 파트너 </p>
        <p className="history-p"> 울산교육연구정보원 울산교육 통합 플랫폼 인프라(클라우드) 구축</p>
        <p className="history-p"> 디비아이엔씨 파트너</p>
        <p className="history-p"> 울산광역시 교육청 학생용 스마트기기 보급사업(2차)</p>
        <p className="history-p"> NHN클라우드 프리미엄 파트너 체결</p>
        <p className="history-p"> 품질경영시스템(ISO 9001) 인증 획득</p>
        <p className="history-p"> KT클라우드 파트너 체결</p>
        <p className="history-p"> 김종열 대표이사 취임</p>
        <p className="history-p"> 기술혁신형 중소기업(Inno-Biz) 선정</p>
        <p className="history-p"> 「혼합현실 제공 서비스를 위한 안내판, 그것을 이용한 3D형상 정보 제공 장치 및 그 방법」 특허등록</p>
        <p className="history-p"> 대구지사 설립</p>
    </div>
);

const History2014 = () => (
    <div>
        <p className="history-tit"> 2018년 ~ 2014년 연혁</p>
        <p className="history-p"> 자회사 ㈜엔시큐리티 설립</p>
        <p className="history-p"> Vmware Professional Partner</p>
        <p className="history-p"> Ahnlab Certified Partner</p>
        <p className="history-p"> LEVITON Network Installer Certification Partner</p>
        <p className="history-p"> TILON Business Alliance</p>
        <p className="history-p"> 한국정보시스템학회 산학부회장 선임(前 이장호 대표이사)</p>
        <p className="history-p"> 「무인비행체를 이용한 배낭형 재난 관측 장치」 특허등록</p>
        <p className="history-p"> 「인보이스 자동화 솔루션」 저작권 프로그램 등록</p>
        <p className="history-p"> 「다기종 로봇 진단 관리 서버」 특허 양수</p>
        <p className="history-p"> 매출 160억(2014년 결산 기준)</p>
        <p className="history-p"> 기업부설연구소 설립</p>
    </div>
);

const History2009 = () => (
    <div>
        <p className="history-tit"> 2013년 ~ 2009년 연혁</p>
        <p className="history-p"> 「장비 이력 관리 솔루션」 저작권 프로그램 등록</p>
        <p className="history-p"> 「소방본부 차량 관제 서비스 솔루션」 저작권 프로그램 등록</p>
        <p className="history-p"> 부산지사 설립</p>
        <p className="history-p"> 매출 100억</p>
        <p className="history-p"> 본사 이전 : 울산 울주군 범서읍 대리로89 경동빌딩 5층</p>
        <p className="history-p"> CISCO Premier Partner</p>
        <p className="history-p"> IBM Business Partner</p>
        <p className="history-p"> EMC Affiliate Partner</p>
        <p className="history-p"> 한드림넷 Gold Partner</p>
        <p className="history-p"> 효성인포메이션시스템 Gold Partner</p>
    </div>
);

const History2003 = () => (
    <div>
        <p className="history-tit"> 2008년 ~ 2003년 연혁</p>
        <p className="history-p"> 본사 이전 : 울산광역시 중구 학산동</p>
        <p className="history-p"> 나우콤(윈스) 보안 전 제품 울산지역 총판</p>
        <p className="history-p"> 시큐브 울산지역 총판 및 기술협력 파트너</p>
        <p className="history-p"> 어울림정보기술 보안 전제품 울산지역 총판</p>
        <p className="history-p"> CISCO 울산지역 Select Partner 총판</p>
        <p className="history-p"> IBM 울산지역 Reseller</p>
        <p className="history-p"> 안철수 방화벽 수호신 울산지역 총판</p>
        <p className="history-p"> 파운드리 네트워크 장비 지역 협력사 체결</p>
        <p className="history-p"> 다산 네트웍스 학내망 울산지역 총판</p>
        <p className="history-p"> 정보통신공사 면허 취득</p>
        <p className="history-p"> 춘해대학 산학 협력사업장 지정</p>
        <p className="history-p"> 한국소프트웨어산업협회 SI 사업자 등록</p>
        <p className="history-p"> ㈜엔정보기술 창립(2003년 02월 10일)</p>
    </div>
);

